<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 10:30:12
 * @LastEditTime: 2020-05-06 17:42:12
 * @Description: 原 PSS 风格页面区
 -->
<template>
  <div class="page">
    <pss-breadcrumb />
    <slot />
  </div>
</template>

<script>
import PssBreadcrumb from './Breadcrumb.vue';

export default {
  name: 'Page',
  components: {
    PssBreadcrumb,
  },
};
</script>

<style lang="less" scoped>
.page {
  flex: 1;
  padding: 16px 0;
  background-color: #fbf9fb;
  border-radius: 16px;
  overflow-x: hidden;
}
</style>
